import { useEffect } from "react";
import "./styles/Painel.css"

const Fields = ({ fields, setFields, funcao }) => {
  const onClickCampo = ( campo ) => {
    console.log("campo = ", campo.campoNome);
    setFields(campo);
  }

  useEffect(() => {
    console.log("Fields recebidos = ", fields);
  },[]);
  return (
    <div className="devices">
      <button onClick={() => funcao(1)}>Voltar</button>
      <h2>Campos desde dispositivo</h2>
      {fields.map((campo) => (
        <div className="devices-preview" key={campo.campoUUID}>
          <h3>Campo: {campo.campoNome}</h3>
          <p>Área total: {campo.areaTotal}</p>
          <p>Criado em: {campo.criadoEm}</p>
          <p>Ultima modificação em: {campo.dataUltimoEvento}</p>
          <button onClick={() => onClickCampo(campo)}>Ver Eventos</button>
        </div>
      ))}
    </div>
  )
}

export default Fields;

/*{fields.fields.map((campo) => (
        <div className="devices-preview" key={campo.campoUUID}>
          <h3>Campo: {campo.campoNome}</h3>
          <p>Área total: {campo.areaTotal}</p>
          <p>Criado em: {campo.criadoEm}</p>
          <p>Ultima modificação em: {campo.dataUltimoEvento}</p>
          <button onClick={() => onClickCampo(campo)}>Ver Eventos</button>
        </div>
      ))}*/